import { BrandsCampaignObjective } from 'lib/enum/brands-campaign-objective.enum';
import { BrandsCampaignRunStatus, BrandsCampaignStatus } from 'lib/enum/brands-campaign-status.enum';
import { BrandsTrafficDestinationType } from 'lib/enum/brands-traffic-destination-type.enum';
import { v4 as uuid } from 'uuid';
import dayjs from 'dayjs';
import { BrandsCampaignType, DraftBrandsCampaign, PublishedBrandsCampaign } from '../BrandsCampaign/types';
import { CampaignEditorType } from 'lib/enum/campaign-editor-type.enum';
import { initialFormValues } from 'components/NewForm/AudienceTargetingPreferences/types';

export const getMockedBrandsCampaign = ({
    startDate = dayjs().toISOString(),
    endDate = dayjs().add(1, 'month').toISOString(),
    status = BrandsCampaignStatus.Active,
} = {}): PublishedBrandsCampaign => ({
    id: uuid(),
    type: BrandsCampaignType.Published,
    fingerprint: 'a3YxP',
    phase: `/api/brands-phases/${uuid()}`,
    socialCampaigns: [],
    historicalManagedSocialCampaigns: [],
    title: 'Brands Campaign Test',
    titleSlug: 'brands-campaign-test',
    objective: BrandsCampaignObjective.Traffic,
    trafficDestination: {
        type: BrandsTrafficDestinationType.LandingPage,
        landingPageUrl: 'https://www.test.com',
        whatsappUrl: null,
        metaLeadForm: null,
    },
    initialStartDate: dayjs().toISOString(),
    period: {
        startDate,
        endDate,
    },
    status,
    advertisements: [],
    adGroups: [],
    lastEditedAt: dayjs().toISOString(),
    runStatus: BrandsCampaignRunStatus.Running,
    lastEditor: {
        type: CampaignEditorType.System,
        user: null,
    },
    issues: [],
    metadata: {
        acri: `~/${uuid()}/brands/${uuid()}`,
    },
    audienceTargetingPreferences: initialFormValues.preferences,
});

export const getMockedDraftBrandsCampaign = ({
    startDate = dayjs().toISOString(),
    endDate = dayjs().add(1, 'month').toISOString(),
    status = BrandsCampaignStatus.Active,
} = {}): DraftBrandsCampaign => ({
    id: uuid(),
    type: BrandsCampaignType.Draft,
    phase: `/api/brands-phases/${uuid()}`,
    title: 'Brands Campaign Test',
    objective: BrandsCampaignObjective.Traffic,
    trafficDestination: {
        type: BrandsTrafficDestinationType.LandingPage,
        landingPageUrl: 'https://www.test.com',
        whatsappUrl: null,
        metaLeadForm: null,
    },
    period: {
        startDate,
        endDate,
    },

    advertisements: [],
    adGroups: [],
    lastEditedAt: dayjs().toISOString(),
    lastEditor: {
        type: CampaignEditorType.System,
        user: null,
    },
    issues: [],
    metadata: {
        acri: `~/${uuid()}/brands/${uuid()}`,
    },
    audienceTargetingPreferences: initialFormValues.preferences,
});
